import { useField } from 'formik'
import { ChangeEvent, FocusEvent, Ref, useCallback } from 'react'
import type { TextAreaRef } from 'antd/lib/input/TextArea'
import { Input as AntdInput } from '../../Input'
import type { TextAreaProps as AntdTextAreaProps } from '../../Input'
import type { FormikFieldProps } from '../typings/FieldProps'

export type TextAreaProps = FormikFieldProps &
  AntdTextAreaProps & {
    ref?: Ref<TextAreaRef>
  }

export const TextArea = ({
  name,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  value: _valueProp,
  ...restProps
}: TextAreaProps) => {
  const [field] = useField(name)
  const { value, onChange, onBlur } = field

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      onChange(event)
      onChangeProp?.(event)
    },
    [onChange, onChangeProp]
  )

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLTextAreaElement>) => {
      onBlur(event)
      onBlurProp?.(event)
    },
    [onBlur, onBlurProp]
  )

  return (
    <AntdInput.TextArea
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      {...restProps}
    />
  )
}
